export const environment = {
    baseURL: process.env.REACT_APP_BASE_URL,
    webSocketBaseURL: process.env.REACT_APP_WS_BASE_URL,
};
